import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import {
  getBrand as onGetBrand,
  addBrand as onAddBrand,
  updateBrand as onUpdateBrand,
  deleteBrand as onDeleteBrand,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import { NameSurname } from "./contactlistCol";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "OnBoarding | Bee Education PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
   const [imageFile, setImageFile] = useState('');



  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {

      title: (contactEdit && contactEdit.OnBoarding_Title) || "",
      sort: (contactEdit && contactEdit.Sort) || "",

    },
    validationSchema: Yup.object({


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          OnBoarding_Title:values.title,
         OnBoarding_Url: imageFile,
         Sort : values.sort,
        };
        dispatch(onUpdateBrand(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          OnBoarding_Title:values["title"],
         OnBoarding_Url: imageFile,
         Sort : values["sort"]
        };
        // save new user
        dispatch(onAddBrand(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.brand,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


    const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };
  

    function showToast(title, message, isSuccess) {
    toastr.options = {
        positionClass: "toast-top-right",
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        newestOnTop: true
    };
    if (isSuccess) {
        toastr.success(message, title);
    } else {
        toastr.error(message, title);
    }
  }

  const handleImageChangeStatus = ({ meta, xhr, remove }, status) => { // 'meta' parametresini ekleyin
    if (status === 'done') {
        const result = JSON.parse(xhr.response);
        setImageFile(result.file.filename);
        // <-- BURAYA EKLEYİN
        showToast("Yükleme Başarılı", `'${meta.name}' adlı resim dosyası yüklendi.`, true);
    }
    if (status === 'removed') {
        setImageFile('');
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
         {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.OnBoarding_Url ? (
              <div className="avatar-xs">
                {cellProps.OnBoarding_Title != null ? <span className="avatar-title rounded-circle">
                  {cellProps.OnBoarding_Title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <a rel="noreferrer" href={'https://megasubdomain.stechomeyazilim.info/'  + cellProps.OnBoarding_Url} target="_blank">
                <img
                  className=" avatar-xl"
                  src={'https://megasubdomain.stechomeyazilim.info/'  + cellProps.OnBoarding_Url}
                  alt=""
                />
              </a>
            )}
          </>
        ),
      },

      {
        Header: "Başlık",
        accessor: "OnBoarding_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

       {
        Header: "Sıralama",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

             
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );



  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetBrand());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };



  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setImageFile(user.OnBoarding_Url)


    setIsEdit(true);


    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteBrand(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };



  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="OnBoarding Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddOnBoarding={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                 

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "OnBoarding Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>
                            
                            
                            
                            <div className="mb-3">
                              <Label className="form-label">Sıralama</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                placeholder="Sıralama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sort || ""}
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                            </div>



                  
                          </Col>
                        </Row>

                             <Row>
                                                  <Col xs={12}>
                                                    <div className="mb-3">
                                <Label>Görsel</Label>
                                {isEdit && imageFile && <div className="mb-2 text-muted">Mevcut Dosya: {imageFile}</div>}
                                <Dropzone
                                    getUploadParams={getUploadParams}
                                    onChangeStatus={handleImageChangeStatus}
                                    maxFiles={1}
                                    multiple={false}
                                    accept="image/*"
                                    inputContent="Resim dosyası sürükleyin veya seçin"
                                />
                            </div>
                                           
                                                  </Col>
                                                </Row>

                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
